// Generated by `bazel run i18n`. Do not edit by hand.
import part0 from "./en/src--common--cancel-order-items.json";
import part1 from "./en/src--common--print-barcode.json";
import part2 from "./en/src--common--shipping-claim--carrier-claim-info.json";
import part3 from "./en/src--common--shipping-claim.json";
import part4 from "./en/src--common.json";
import part5 from "./en/src--mobile-launcher.json";
import part6 from "./en/src--order-edits--filters.json";
import part7 from "./en/src--order-edits.json";
import part8 from "./en/src--scan--modals.json";
import part9 from "./en/src--scan--packing-station.json";
import part10 from "./en/src--setting--about-oms.json";
import part11 from "./en/src--setting--automations.json";
import part12 from "./en/src--setting--carrier-accounts.json";
import part13 from "./en/src--setting--components.json";
import part14 from "./en/src--setting--customs.json";
import part15 from "./en/src--setting--integration-utils.json";
import part16 from "./en/src--setting--locations.json";
import part17 from "./en/src--setting--markets--editor.json";
import part18 from "./en/src--setting--markets.json";
import part19 from "./en/src--setting--oms.json";
import part20 from "./en/src--setting--photo-instructions.json";
import part21 from "./en/src--setting--presets.json";
import part22 from "./en/src--setting--printing.json";
import part23 from "./en/src--setting--reports.json";
import part24 from "./en/src--setting--restrictions.json";
import part25 from "./en/src--setting--return-addresses.json";
import part26 from "./en/src--setting--routing-rules.json";
import part27 from "./en/src--setting--totes.json";
import part28 from "./en/src--setting--work-order-flows.json";
import part29 from "./en/src--setting.json";
import part30 from "./en/src--shipping-claims.json";
import part31 from "./en/src--wms--bin-assignment.json";
import part32 from "./en/src--wms--bin-count.json";
import part33 from "./en/src--wms--consolidation.json";
import part34 from "./en/src--wms--dashboard.json";
import part35 from "./en/src--wms--flush.json";
import part36 from "./en/src--wms--instant-transfer.json";
import part37 from "./en/src--wms--inventory-level-ledger.json";
import part38 from "./en/src--wms--item-photo-request.json";
import part39 from "./en/src--wms--pick-sessions--create-pick-session-modals.json";
import part40 from "./en/src--wms--pick-sessions.json";
import part41 from "./en/src--wms--receive-to-bin.json";
import part42 from "./en/src--wms--receiving.json";
import part43 from "./en/src--wms--replenishment-report.json";
import part44 from "./en/src--wms--replenishment.json";
import part45 from "./en/src--wms--shared.json";
import part46 from "./en/src--wms--sku-lookup.json";
import part47 from "./en/src--wms--transfer.json";
import part48 from "./en/src--wms--work-order-station.json";
import part49 from "./en/src.json";

export default Object.assign(
  {},
  part0,
  part1,
  part2,
  part3,
  part4,
  part5,
  part6,
  part7,
  part8,
  part9,
  part10,
  part11,
  part12,
  part13,
  part14,
  part15,
  part16,
  part17,
  part18,
  part19,
  part20,
  part21,
  part22,
  part23,
  part24,
  part25,
  part26,
  part27,
  part28,
  part29,
  part30,
  part31,
  part32,
  part33,
  part34,
  part35,
  part36,
  part37,
  part38,
  part39,
  part40,
  part41,
  part42,
  part43,
  part44,
  part45,
  part46,
  part47,
  part48,
  part49,
);
